import { ru } from './locales/ru';
import { uzLatn } from './locales/uz-Latn';
/**
 * Локали приложения курьера и кабинета (FR-557…FR-560).
 *
 * `uz-Latn` — по умолчанию. Русская локаль типизирована по узбекской, поэтому
 * расхождение состава ключей не соберётся.
 */
export const LOCALES = ['uz-Latn', 'ru'];
export const DEFAULT_LOCALE = 'uz-Latn';
const BUNDLES = {
    'uz-Latn': uzLatn,
    ru,
};
export function messagesFor(locale) {
    return BUNDLES[locale];
}
/**
 * Приводит тег языка к поддерживаемой локали.
 *
 * `uz`, `uz-UZ`, `uz-Latn-UZ` — всё это узбекский. Системная локаль устройства
 * приходит в произвольном виде, и точное сравнение строк отправило бы половину
 * курьеров на русский интерфейс.
 */
export function resolveLocale(tag) {
    if (tag === undefined || tag === null || tag.trim() === '') {
        return DEFAULT_LOCALE;
    }
    const base = tag.trim().toLowerCase().split('-')[0];
    if (base === 'uz') {
        return 'uz-Latn';
    }
    if (base === 'ru') {
        return 'ru';
    }
    return DEFAULT_LOCALE;
}
/** Все ключи локали в виде плоских путей: `shift.start`, `stop.navigate`. */
export function flattenKeys(messages, prefix = '') {
    return Object.entries(messages).flatMap(([key, value]) => {
        const path = prefix === '' ? key : `${prefix}.${key}`;
        return typeof value === 'object' && value !== null
            ? flattenKeys(value, path)
            : [path];
    });
}
export function pluralIndex(locale, count) {
    if (locale !== 'ru') {
        return 0;
    }
    const absolute = Math.abs(count) % 100;
    const last = absolute % 10;
    // Одиннадцать–четырнадцать ведут себя как «много» вопреки последней цифре.
    if (absolute >= 11 && absolute <= 14) {
        return 2;
    }
    if (last === 1) {
        return 0;
    }
    return last >= 2 && last <= 4 ? 1 : 2;
}
export function plural(locale, count, forms) {
    return `${count} ${forms[pluralIndex(locale, count)]}`;
}
export { ru, uzLatn };
//# sourceMappingURL=index.js.map